var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"custom-height",attrs:{"fluid":_vm.$router.currentRoute.name === 'kiosk'}},[_c('router-view'),_c('order-preview-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }